export enum AppTypeName {
  CrossAccountApp = 'CrossAccountApp',
  CrossTenantReceivingApp = 'CrossTenantReceivingApp',
  CrossTenantSendingApp = 'CrossTenantSendingApp',
  ExternalApp = 'ExternalApp',
  ManagedApp = 'ManagedApp'
}